import LanguageSwitcher from '../LanguageSwitcher';

/**
 * Shared chrome for public auth pages: optional logo + language switcher.
 */
function AuthPageChrome({ logoSrc, logoAlt = 'Apex Analytics', children }) {
  return (
    <>
      <div className="auth-page-chrome">
        {logoSrc && (
          <img className="company-logo" src={logoSrc} alt={logoAlt} />
        )}
        <LanguageSwitcher variant="auth" />
      </div>
      {children}
    </>
  );
}

export default AuthPageChrome;
